'use strict';
import { HeaderBase } from './HeaderBase';
import Render from './HeaderRender';
import { connect } from 'react-redux';

class Header extends HeaderBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

// export default Header
export default Header = connect((state)=>{
    return {user:state.user || {}}
})(Header);
